import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import MassMessageDetails from './MassMessageDetails';
import LegacyMassMessageDetails from '../../../../components/Routes/Messaging/MassMessaging/MassMessageDetails';

const MassMessageDetailsGate = props => {
  const flags = useFlags();
  if (flags.events) return <MassMessageDetails {...props} />;
  return <LegacyMassMessageDetails {...props} />;
};

export default MassMessageDetailsGate;
